<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import createBlock from "./create_block.vue";

export default {
  page: {
    title: "İp Blokları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    createBlock,
  },
  data() {
    return {
        list: {},
        title: "IP BLOKLARI",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "IP BLOKLARI",
            active: true,
          },
        ],
        isLoading: false,
        rows: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        selected: 0,
        pageLength: 0,
        url: "logs/ipblock",
        paginationOptions: {
          enabled: true,
          dropdownAllowAll: false,
          perPage: 50,
          setCurrentPage: 1,
          perPageDropdown: [50, 100, 200],
          nextLabel: 'Sonraki',
          prevLabel: 'Önceki',
          rowsPerPageLabel: 'Kayıt Göster',
          ofLabel: 'of',
          pageLabel: 'sayfa', // for 'pages' mode
          infoFn: params => `${params.firstRecordOnPage} - ${params.lastRecordOnPage} ( Toplam: ${params.totalRecords}) `,
      },
      selectOptions: {
        enabled: false,
        selectOnCheckboxOnly: false,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
      columns: [
        {
          label: 'Opertör',
          field: 'operator',
        },
        {
          label: 'Servis Tipi',
          field: 'service_type',
          sortable: false,
        },
        {
          label: 'Başlangıç İp',
          field: 'start_ip',
          sortable: false,
        },
        {
          label: 'Bitiş İp',
          field: 'end_ip',
          sortable: false,
        },
        {
          label: 'Nat Durumu',
          field: 'nat',
          sortable: false,
        },
        {
          label: 'Tahsis Başlangıç T.',
          field: 'start_date',
          sortable: false,
        },
        {
          label: 'Tahsis Bitiş',
          field: 'end_date',
          sortable: false,
        },
        {
          label: 'Ip Tip',
          field: 'ip_tip',
          sortable: false,
        },
        {
          label: 'Lokasyon',
          field: 'location',
        },
        {
          field: '#',
          sortable: false,
          thClass: 'width-50',
        },
      ],
    };
  },
   mounted() {
        this.loadItems()
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
      })
    },
    getFromServer() {
    return new Promise((resolve, reject) => {
        this.$http.post(this.url, this.serverParams)
          .then(res => {
            resolve({
              rows: res.data.data,
              totalRecords: res.data.total,
              pageLength: res.data.last_page,
              currentPage: res.data.current_page,
            })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    selectionChanged(a) {
      this.selected = a.selectedRows.length
    },
    onSearch(params) {
       this.updateParams(params)
        this.loadItems()
    },
    create(){
       this.list = {}
       this.$parent.$bvModal.show('modal-scoped')
    },
    update(props){
       this.list = props
       this.$parent.$bvModal.show('modal-scoped')
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <create-block :list="list" @loadItems="loadItems" />
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{
                    enabled: false,
                    placeholder: 'Arama İçin Enter\'a Basınız'
                  }"
                @on-search="onSearch"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-selected-rows-change="selectionChanged"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <div slot="table-actions">
                    <button 
                    class="btn btn-success" 
                    style="margin-right:10px;margin-top:2px" 
                    type="button" 
                    @click="create()"
                    ><i class="mdi mdi-plus"></i>  Yeni Oluştur
                    </button>
                </div>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <span
                    v-if="props.column.field === '#'"
                    class="text-nowrap"
                  >
                     <ul class="list-inline font-size-20 contact-links mb-0">
                        <li class="list-inline-item">
                          <a v-b-tooltip.hover title="Düzenle" @click="update(props.row)">
                            <i class="mdi mdi-circle-edit-outline"></i>
                          </a>
                        </li>
                      </ul>
                  </span>
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
  </Layout>
</template>